<template>
  <ValidationProvider tag="div" :rules="rules" :name="name" :vid="vid" v-slot="{ errors }" :mode="mode">
    <input
      :type="type"
      v-model="inner.value"
      ref="input"
      :class="[
        inputClass,
        {
          'is-invalid': errors.length,
        },
      ]"
      :disabled="disabled"
    />
    <template v-if="errors">
      <b-tooltip v-if="errorMode == 'tooltip'" :target="() => $refs['input']" :title="errors.length ? errors[0] : null" variant="danger" noninteractive placement="top" boundary="window"></b-tooltip>
      <div v-else class="text-danger">
        {{ errors[0] }}
      </div>
    </template>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { BTooltip } from "bootstrap-vue";

export default {
  name: "InputText",
  components: {
    ValidationProvider,
    BTooltip,
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    name: {
      type: String,
      default: undefined,
    },
    vid: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: "text",
    },
    mode: {
      type: String,
      default: "eager",
    },
    inputClass: {
      type: String,
      default: "form-control form-control-sm",
    },
    errorMode: {
      type: String,
      default: "normal",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inner: {
        value: this.value,
      },
    };
  },
  watch: {
    "inner.value"(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.inner.value = val;
    },
  },
};
</script>
